<template>
  <div
    class="tw-group tw-relative tw-shadow tw-min-h-36 tw-w-full tw-rounded-[4px] tw-bg-white tw-p-4 tw-transition-shadow tw-flex tw-flex-col tw-justify-between tw-content-start"
  >
    <div class="tw-flex tw-justify-between">
      <slot name="title"></slot>
    </div>
    <div class="tw-mb-3" v-if="slots['filters']">
      <slot name="filters"></slot>
    </div>
    <div class="tw-mb-3" v-if="slots['body']">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { VNode } from "vue";
const slots = defineSlots<{
  title: () => VNode | VNode[];
  filters?: () => VNode | VNode[];
  body?: () => VNode | VNode[];
}>();
</script>
